import React, { useEffect, useState } from 'react';
import { Loading } from 'v3/components'

const IconSortNone = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24">
    <path
      d="M7 10l5-5 5 5M7 14l5 5 5-5"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      opacity="0.7"
    />
  </svg>
);

const IconSortAsc = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24">
    <path
      d="M12 6l4 4H8l4-4zm0 12v-8"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const IconSortDesc = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24">
    <path
      d="M12 18l-4-4h8l-4 4zm0-12v8"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const SortIcon = ({ direction, loading }) => {
  const [rendered, setRendered] = useState(direction);

  useEffect(() => {
    setRendered(direction);
  }, [direction]);

  const commonStyle = {
    transition: 'opacity 0.25s ease, transform 0.25s ease',
    position: 'absolute',
  };

  const iconStyles = {
    none: {
      opacity: direction === "none" ? 1 : 0,
      transform: direction === "none" ? "scale(1)" : "scale(0.5)",
    },
    asc: {
      opacity: direction === "ASC" ? 1 : 0,
      transform: direction === "ASC" ? "rotate(0deg)" : "rotate(-90deg)",
    },
    desc: {
      opacity: direction === "DESC" ? 1 : 0,
      transform: direction === "DESC" ? "rotate(0deg)" : "rotate(90deg)",
    },
  };

  return (
    <>
      {loading ? (
        <Loading size={16} />
      ) : (
        <div style={{ width: 22, height: 22, position: "relative" }}>
          <div style={{ ...commonStyle, ...iconStyles.none }}>
            <IconSortNone />
          </div>
          <div style={{ ...commonStyle, ...iconStyles.asc }}>
            <IconSortAsc />
          </div>
          <div style={{ ...commonStyle, ...iconStyles.desc }}>
            <IconSortDesc />
          </div>
        </div>
      )}
    </>
  );
};

export default SortIcon;
